import { useQuery } from "@tanstack/react-query";

export interface BillingOverviewData {
  totalRevenue: number;
  outstandingInvoices: number;
  mrr: number;
  churnRate: number;
  revenueTrend: Array<{ date: string; amount: number }>;
  invoicesByStatus: Array<{ status: string; count: number; total: number }>;
  topClientsBySpend: Array<{ clientId: number; name: string; spend: number }>;
}

export interface DateRange {
  dateFrom?: string;
  dateTo?: string;
}

export function useBillingOverview(dateRange?: DateRange) {
  const queryParams = new URLSearchParams();
  if (dateRange?.dateFrom) queryParams.append('dateFrom', dateRange.dateFrom);
  if (dateRange?.dateTo) queryParams.append('dateTo', dateRange.dateTo);
  
  const queryString = queryParams.toString();
  const queryKey = queryString ? `/api/v1/admin/billing/overview?${queryString}` : '/api/v1/admin/billing/overview';

  return useQuery<BillingOverviewData>({
    queryKey: [queryKey],
    enabled: true,
  });
}